const initCarousels = (root = document) => {
  const slideshowNodes = root.querySelectorAll(".embla");
  slideshowNodes.forEach((slideshowNode) => {
    if (slideshowNode.dataset.emblaInitialized === "true") {
      return;
    }

    const viewportNode = slideshowNode.querySelector(".embla__viewport");
    const prevButtonNode = slideshowNode.querySelector(".embla__prev");
    const nextButtonNode = slideshowNode.querySelector(".embla__next");

    if (!viewportNode) {
      return;
    }

    const embla = EmblaCarousel(viewportNode, { loop: true, align: "start" }, [
      EmblaCarouselAutoplay({ stopOnInteraction: false, stopOnMouseEnter: true }),
    ]);
    slideshowNode.dataset.emblaInitialized = "true";

    let hideNavTimeout;
    const setNavVisibility = (visible) => {
      const displayValue = visible ? "block" : "none";

      if (prevButtonNode) {
        prevButtonNode.style.display = displayValue;
      }

      if (nextButtonNode) {
        nextButtonNode.style.display = displayValue;
      }
    };
    const showNav = () => {
      clearTimeout(hideNavTimeout);
      setNavVisibility(true);
    };
    const hideNav = () => {
      clearTimeout(hideNavTimeout);
      hideNavTimeout = setTimeout(() => {
        if (slideshowNode.matches(":hover") || slideshowNode.contains(document.activeElement)) {
          return;
        }

        setNavVisibility(false);
      }, 0);
    };

    setNavVisibility(false);
    slideshowNode.addEventListener("mouseenter", showNav);
    slideshowNode.addEventListener("mouseleave", hideNav);
    slideshowNode.addEventListener("focusin", showNav);
    slideshowNode.addEventListener("focusout", hideNav);

    if (prevButtonNode) {
      prevButtonNode.addEventListener("click", () => embla.scrollPrev(), false);
    }

    if (nextButtonNode) {
      nextButtonNode.addEventListener("click", () => embla.scrollNext(), false);
    }
  });
};

window.clpeInitCarousels = initCarousels;

document.addEventListener("DOMContentLoaded", async () => {
  initCarousels();
});
